import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  useTheme,
} from "@mui/material";
import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import CloseIcon from "@mui/icons-material/Close";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PropTypes from 'prop-types'

const CourtesyRidesPopup = ({ open, onClose, handleGoToLyft }) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="courtesy-rides-title"
      aria-describedby="courtesy-rides-description"
      sx={{
        [theme.breakpoints.down("lg")]: {
          fontSize: "12px",
        },
      }}
      PaperProps={{
        sx: {
          width: "70%",
          maxWidth: "880px",
          alignItems: "center",
          gap: "1em",
          [theme.breakpoints.down("lg")]: {
            gap: "0em",
          },
        },
      }}
    >
      <IconButton
        aria-label="close modal"
        onClick={onClose}
        sx={{ alignSelf: "flex-end", margin: ".5em 1em 0em 1em" }}
      >
        <CloseIcon style={{ padding: 0 }} />
      </IconButton>
      <DialogTitle
        sx={{ fontSize: "2.8rem", padding: ".125em", fontWeight: "600" }}
        id="courtesy-rides-title"
      >
        Courtesy Rides
      </DialogTitle>
      <DialogContent sx={{ display: "grid" }}>
        <DialogContentText
          id="courtesy-rides-description"
          sx={{ textAlign: "center", marginBottom: ".7rem" }}
        >
          Courtesy rides is a complimentary service stores can use to minimize
          the number of customers waiting at the store, while saving operational
          costs and improving store production.
        </DialogContentText>

        <div className='courtesy-rides-grid-columns'>
          <div className='courtesy-rides-grid-column'>
            <div className='courtesy-rides-grid-title'>Using Store's vehicle</div>
            <div className='courtesy-rides-grid-item'>
              <AccessTimeIcon className='courtesy-rides-icon-item' />
              Need 24 minutes of a crew member
            </div>
            <div className='courtesy-rides-grid-item'>
              <PermPhoneMsgIcon className='courtesy-rides-icon-item' />
              On-call for possible return ride
            </div>
            <div className='courtesy-rides-grid-item'>
              <AttachMoneyIcon className='courtesy-rides-icon-item' />
              Average Cost is $10 PLUS store productivity
            </div>
          </div>
          <div className='courtesy-rides-grid-column'>
            <div className='courtesy-rides-grid-title'>vs</div>
            <div className='courtesy-rides-grid-item'></div>
            <div className='courtesy-rides-grid-item'></div>
            <div className='courtesy-rides-grid-item'></div>
          </div>
          <div className='courtesy-rides-grid-column'>
            <div className='courtesy-rides-grid-title'>Using Lyft</div>
            <div className='courtesy-rides-grid-item'>
              <AccessTimeIcon className='courtesy-rides-icon-item' />
              No crew member time needed
            </div>
            <div className='courtesy-rides-grid-item'>
              <PermPhoneMsgIcon className='courtesy-rides-icon-item' />
              Return ride link is automatically sent
            </div>
            <div className='courtesy-rides-grid-item'>
              <AttachMoneyIcon className='courtesy-rides-icon-item' />
              Average cost is $15 and no crew time
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions sx={{ gap: "4.5em", marginTop: "2em" }}>
        <button
          className="button red"
          style={{ fontSize: "1rem", fontWeight: "700" }}
          onClick={onClose}
        >
          Return to Message Runner
        </button>
        <button
          className="button red"
          style={{ fontSize: "1rem", fontWeight: "700" }}
          autoFocus
          onClick={handleGoToLyft}
        >
          Select Lyft
        </button>
      </DialogActions>
    </Dialog>
  );
};

CourtesyRidesPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  handleGoToLyft: PropTypes.func
}

export default CourtesyRidesPopup;
